import axios from 'axios'
// process.env.NODE_TLS_REJECT_UNAUTHORIZED = ''
// import https from 'https'
const token = localStorage.getItem('token')
if (token) axios.defaults.headers.common.authkey = localStorage.getItem('token')
axios.interceptors.response.use((res) => {
  if (res.data.token) {
    console.log('authorization : ' + res.data.token)
    localStorage.setItem('token', res.data.token)
    axios.defaults.headers.common.authkey = localStorage.getItem('token')
  }
  return Promise.resolve(res)
}, (err) => {
  console.log(err)
  if (err.response.status === 403) {
    localStorage.clear()
    this.$store.commit('delToken');
    this.$axios.defaults.headers.common['x-access-token'] = undefined;
    this.$router.push('/').catch(()=> {});
    return
  }
  return Promise.reject(err)
})
let url = window.location.href
if (url.includes('localhost')) axios.defaults.baseURL = 'http://localhost/'
else if (url.includes('https')) axios.defaults.baseURL = 'https://www.ai8760.co.kr/'
else axios.defaults.baseURL = 'http://www.ai8760.co.kr/'

// axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:81/api/' : 'https://simeo.co.kr:8001/api/'
/*
const instance = axios.create({
  httpsAgent: new https.Agent({
    rejectUnauthorized: false
  })
})
https.globalAgent.options.rejectUnauthorized = false
*/
// axios.defaults.withCredentials = true
// axios.defaults.headers.Access-Control-Allow-Origin:
// axios.defaults.baseURL = 'http://127.0.0.1:81/api/'
export default axios
